import Carousel from 'react-bootstrap/Carousel'
import Image from 'react-bootstrap/Image'
import InitiateMessage from "./InitiateMessage"
import Button from 'react-bootstrap/Button';
import React, { useContext, useState, useEffect } from "react"
import { AuthContext } from "../../context/AuthContext"
import {
    doc,
    updateDoc,
    arrayUnion,
    arrayRemove,
    deleteDoc,
    getDoc
} from "firebase/firestore"
import { db, model } from "../../firebase"
import { useListingsContext } from "../../context/ListingsContext"
import ModalWrapper from '../ModalWrapper';
import EditListing from './EditListing';
import ArchiveListing from './ArchiveListing';
import { useNavigate } from 'react-router-dom';
import { LoginModalContext } from "../../context/LoginModalContext";
import { NavLink } from 'react-router-dom';

// const { ImageAnalysisClient } = require('@azure-rest/ai-vision-image-analysis');
// const createClient = require('@azure-rest/ai-vision-image-analysis').default;
// const { AzureKeyCredential } = require('@azure/core-auth');

// // const endpoint = process.env['VISION_ENDPOINT'];
// // const key = process.env['VISION_KEY'];
// const endpoint = "https://phreesh.cognitiveservices.azure.com/";
// const key = "7VNFJ9MCdrPgwDhAGovP8puRSqwSZqEqK9v912ojquFUa1mRtJwKJQQJ99BJACYeBjFXJ3w3AAAFACOGUlI2";

// const credential = new AzureKeyCredential(key);
// const client = createClient(endpoint, credential);

const ItemDisplay = ({listing}) => {
    
    const [activeBids, setActiveBids] = useState([])
    const [editListingOpen, setEditListingOpen] = useState(false)
    const [archiveListingOpen, setArchiveListingOpen] = useState(false)
    const [listingItem, setListingItem] = useState(listing)
    const [sellerPicture, setSellerPicture] = useState("")
    const { currentUser } = useContext(AuthContext)
    console.log(currentUser)
    console.log(listing)
    // const listings = useListingsContext().listings
    // const updateListings = useListingsContext().updateListings
    const { setLoginModalOpen } = useContext(LoginModalContext)
    const navigate = useNavigate()

    const hasUserSentMessage = (user) => {
        if (user) {
            // return (user.activeChats.buying.some(e => e.listingId === listing.id))
            return (user.activeChats.some(e => e.listingId === listing.id))
        }
    }

    const getUserPicture = async(userId) => {
        try {
            const userSnapshot = await getDoc(doc(db, "users", userId))
            const userInfo = userSnapshot.data()
            setSellerPicture(userInfo.avatarUrl)
        } catch (err) {
            console.error(err.message)
        }
    }

    useEffect(() => {
        getUserPicture(listingItem.user.userId)
    },[listingItem])

    // const listingItem = listing.listing
    // console.log(listingItem)

    const saveListing = async () => {
        console.log(currentUser)
        console.log(listingItem)
        await updateDoc(
            doc(db, `users/${currentUser.uid}/private`, "data"),{
            activeBids: arrayUnion(listingItem.id)
        }).then(res => {
            console.log(res)
            console.log(currentUser.activeBids, "1")
            currentUser.activeBids = [...currentUser.activeBids, listingItem.id]
            console.log(currentUser.activeBids, "2")
            setActiveBids(currentUser.activeBids)
            console.log(currentUser)
        })
        await updateDoc(doc(db, "listings", listingItem.id), {
            bidders: arrayUnion(currentUser.email)
        })
    }

    const unsaveListing = async () => {
        console.log(currentUser)
        console.log(listingItem)
        await updateDoc(doc(db, "users", currentUser.uid),{
            activeBids: arrayRemove(listingItem.id)
        }).then(res => {
            console.log(res)
            console.log(currentUser.activeBids, "1")
            const listingIndex = currentUser.activeBids.indexOf(listingItem.id)
            currentUser.activeBids.splice(listingIndex, 1)
            console.log(currentUser.activeBids, "2")
            const newArray = [...currentUser.activeBids]
            setActiveBids(newArray)
            console.log(currentUser)
            // debugger
        })
        await updateDoc(doc(db, "listings", listingItem.id), {
            bidders: arrayRemove(currentUser.email)
        })
    }

    // const archiveListing = async (listing_id) => {
    //     await updateDoc(doc(db, "listings", listing_id),{
    //         active: false,
    //         acquired_by: 
    //     }).then(res => {
    //         console.log(res)
    //         // currentUser.activeBids = [listingItem.listing_id]
    //         // setActiveBids(currentUser.activeBids)
    //         // console.log(currentUser)
    //     })
    // }

    const onDeleteClick = async (id) => {
        const res = window.confirm("Are you sure you want to delete this listing?")
        if (res) {
            try {
                // debugger
                await deleteDoc(doc(db,`listings/${id}/private`, "data"))
                await deleteDoc(doc(db, "listings", id))
                if (listingItem.chatrooms) {
                    listingItem.chatrooms.map(chatroom => {
                        updateDoc(doc(db, "chatrooms", chatroom),{
                            active: false
                        })
                    })
                }
                // const updatedListings = listings.filter((listing) => listing.id !== id)
                // console.log(updatedListings)
                // updateListings(updatedListings)
                navigate(`/archive`)
            } catch (err) {
                console.error(err.message)
            }
        }
    }

    if (!listingItem.active && currentUser && (listingItem.user.userId !== currentUser.uid)) {
        return (
        <div className="404-page">
            Sorry, this listing is unavailable. It may have been archived or deleted.
        </div> )
    }

    const handleNoUserClick = (e) => {
        if (!currentUser) {
            e.preventDefault()
            setLoginModalOpen(true)
        }
    }

    // const features = [
    //     'Caption',
    //     'Read',
    //     'Tags'
    //   ];
    
    // const onAnalyzeImage = async(imageUrl) => {
        // const result = await client.path('/imageanalysis:analyze').post({
        //     body: {
        //         url: imageUrl
        //     },
        //     queryParameters: {
        //         features: features,
        //         'language': 'en',
        //         'gender-neutral-captions': 'true',
        //         'smartCrops-aspect-ratios': [0.9, 1.33]
        //     },
        //     contentType: 'application/json'
        // });
        // console.log(result)
        // return result
    // }

    return (
        <div className='item-display-content'>
            <div className='carousel-div'>
                <Carousel>
                    {listingItem.image_urls.map((image, i) => (
                        <Carousel.Item key={`carousel-item-${i}`} id='carousel-item'>
                            <Image src={image} key={`carousel-image-${i}`} id='carousel-image' fluid/>
                        </Carousel.Item>
                    ))}
                </Carousel>
            </div>

            <div className='item-display-info'>

                <div className='listing-info-container'>
                    <div className='listing-info'>
                        <div className='listing-title'>{listingItem.title}</div>
                        <div>${listingItem.price}</div>
                        <div className='item-display-description'>{listingItem.description}</div>
                    </div>
                    {currentUser && currentUser.uid !== listing.user.userId?
                        currentUser.emailVerified && currentUser.activeBids && currentUser.activeBids.includes(listingItem.id)? 
                        <Button variant="secondary" className="dibs-button" onClick={unsaveListing} title='Unsave'>
                            <i className="material-icons" title='Unsave'> bookmark_remove </i>
                        </Button> : 
                        <Button variant="primary" className="dibs-button" onClick={saveListing} title="Save">
                            <i className="material-icons" title='Save'> bookmark_add </i>
                        </Button>
                    : null
                    }
                </div>
                <hr id='solid'/>

                
                {currentUser ? 
                <NavLink className="item-display-seller-info"  
                    to={{
                        pathname: `/user/${listingItem.user.userId}`,
                    }}
                >
                    {sellerPicture ?
                    <img src={sellerPicture} className="avatar item-display-avatar"/>:
                    <i className="material-icons item-display-avatar">account_circle</i>}
                    {listingItem.user.firstName}
                </NavLink> :
                <NavLink className="item-display-seller-info"  
                onClick={handleNoUserClick}
                >
                    {sellerPicture ?
                    <img src={sellerPicture} className="avatar item-display-avatar"/>:
                    <i className="material-icons item-display-avatar">account_circle</i>}
                    {listingItem.user.firstName}
                </NavLink>
                }

                {currentUser && listingItem.user.userId === currentUser.uid ?
                <div className='listing-interactive'>
                    <ModalWrapper 
                        show={editListingOpen}
                        onHide={() => setEditListingOpen(false)}
                        heading="Edit Listing"
                    >
                        <EditListing
                            listing={listingItem}
                            setListingItem={setListingItem}
                            onHide={() => setEditListingOpen(false)}
                        />
                    </ModalWrapper>
                    <ModalWrapper 
                        show={archiveListingOpen}
                        onHide={() => setArchiveListingOpen(false)}
                        heading="Archive Listing"
                    >
                        <ArchiveListing
                            listing={listingItem}
                            onHide={() => setArchiveListingOpen(false)}
                        />
                    </ModalWrapper>
                    {
                        listingItem.active?
                        <div>
                            <Button
                                type="button"
                                className="btn btn-primary"
                                // data-bs-toggle="modal" data-bs-target={`#id${listing.listing_id}`}
                                onClick={() => setEditListingOpen(true)}
                            >
                                Edit
                            </Button>
                            <Button className='btn btn-primary' onClick={() => setArchiveListingOpen(true)}>
                                Mark as sold
                            </Button>
                        </div>:
                        <div>
                            <p>Acquired by {listingItem.acquired_by}</p>
                            <p>This listing has been archived</p>
                        </div>
                    }
                    <button className='btn btn-danger' onClick={() => onDeleteClick(listingItem.id)}>Delete Listing</button>
                </div> :

                currentUser? 
                    currentUser.emailVerified ? 
                        <div className='listing-interactive'>
                            <div>Chat with {listingItem.user.firstName}</div>
                            <InitiateMessage listing={listingItem} disabled={hasUserSentMessage(currentUser)}/>
                        </div> 
                    :
                        <div className='listing-interactive'>
                            <div className='alert alert-danger'>Please verify your e-mail to unlock full access to Phressh!</div>
                            <div>Chat with {listingItem.user.firstName}</div>
                            <InitiateMessage listing={listingItem} disabled={true}/>
                            {currentUser && currentUser.activeBids && currentUser.activeBids.includes(listingItem.id) ? 
                                <Button className='btn-secondary' disabled>You've placed dibs!</Button> : 
                                <Button disabled>Place dibs</Button>
                            }
                        </div> 
                :
                    <div className='listing-interactive'>
                        <Button className="btn-success" onClick={handleNoUserClick}>Chat with {listingItem.user.firstName}</Button>
                    </div>

                }
            </div>
        </div>
    )
}

export default ItemDisplay